module.exports = __webpack_public_path__ + "img/maletin-default.a5502588.png";